export enum CustomerAssessmentResultIconsEnum {

    not_applicable = '',
    poor = 'fa-regular fa-face-eyes-xmarks',
    below_average = 'fa-regular fa-face-confused',
    average = 'fa-regular fa-meh',
    good = 'fa-regular fa-smile-relaxed',
    excellent = 'fa-regular fa-face-grin-stars'

}